// removed by extract-text-webpack-plugin
module.exports = {"comment":"_2j4X6syT","buttonArea":"A4N1EWLV","button":"_1AOmUys8","buttonLeft":"_3ar_Hwbr _1AOmUys8","buttonRight":"_3g1pG40X _1AOmUys8"};


//////////////////
// WEBPACK FOOTER
// ./app/orders/components/order-card/ums-order-card.styles.scss
// module id = 695
// module chunks = 0